'use client';

import React, { useState, useEffect } from 'react';
import { useRouter, useSearchParams } from 'next/navigation';
import { PasswordLoginForm, type PasswordLoginFormValues } from '@org/ui';
import { useAuth } from '@/components/AuthContext';

export default function LoginForm() {
  const { login, error: authError, isAuthenticated, isLoading: authLoading } = useAuth();
  const router = useRouter();
  const searchParams = useSearchParams();
  const redirectPath = searchParams.get('redirect') || '/';

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (isAuthenticated && !authLoading) {
      router.push(redirectPath);
    }
  }, [isAuthenticated, authLoading, redirectPath, router]);

  useEffect(() => {
    if (authError) {
      setError(authError);
    }
  }, [authError]);

  const handleSubmit = async (values: PasswordLoginFormValues) => {
    setIsSubmitting(true);
    setError(null);

    try {
      const success = await login(values.login, values.password, values.remember);
      if (success) {
        router.push(redirectPath);
        return;
      }
      setError(authError || 'Ошибка авторизации. Проверьте логин и пароль.');
    } catch (err) {
      setError((err as Error).message || 'Произошла ошибка при авторизации. Попробуйте позже.');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <PasswordLoginForm
      onSubmit={handleSubmit}
      submitting={isSubmitting}
      errorMessage={error}
      initialValues={{ remember: true }}
      onValuesChange={() => setError(null)}
    />
  );
}
